import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { AlertsPageComponent } from './alerts.component';

const routes: Routes = [
  {
    component: AlertsPageComponent,
    path: ''
  }
];

@NgModule({
  exports: [RouterModule],
  imports: [RouterModule.forChild(routes)]
})
export class AlertsPageRoutingModule {}
